import React from 'react';
import { Link } from 'react-router-dom';

const projects = [
  {
    id: 1,
    name: 'Website Redesign',
    progress: 75,
    team: [
      { name: 'John Doe', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80' },
      { name: 'Jane Smith', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80' },
      { name: 'Mike Johnson', avatar: 'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80' },
    ],
    tasks: { completed: 12, total: 16 },
    dueDate: '2024-03-15',
  },
  // ... other projects
];

const Dashboard = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {projects.map((project) => (
          <div
            key={project.id}
            className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-medium text-gray-900">{project.name}</h3>
              <span className="text-sm text-gray-500">Due {project.dueDate}</span>
            </div>

            {/* Progress bar */}
            <div className="mb-4">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-gray-700">Progress</span>
                <span className="text-sm font-medium text-gray-700">{project.progress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-[#009efb] h-2 rounded-full transition-all duration-300"
                  style={{ width: `${project.progress}%` }}
                />
              </div>
            </div>

            {/* Team members */}
            <div className="flex items-center mb-4">
              <div className="flex -space-x-2">
                {project.team.map((member, index) => (
                  <img
                    key={index}
                    className="h-8 w-8 rounded-full border-2 border-white"
                    src={member.avatar}
                    alt={member.name}
                  />
                ))}
              </div>
              <span className="ml-2 text-sm text-gray-500">
                {project.tasks.completed}/{project.tasks.total} tasks completed
              </span>
            </div>

            <Link
              to={`/projects/${project.id}`}
              className="block w-full text-center px-4 py-2 text-sm font-medium text-white bg-[#009efb] rounded-md hover:bg-[#009efb] transition-colors duration-200"
            >
              View Project
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard; 